export default function Logos () {
  const SECTION = document.querySelector('.dm-logos')
  if (!SECTION) return

  const LOGOS = SECTION.querySelectorAll('.dm-secondary-logo')
  const FORMAT_SELECT = SECTION.querySelector('#logo-select')

  if (LOGOS.length === 0 || !FORMAT_SELECT) return

  FORMAT_SELECT.addEventListener('change', (e) => {
    const SELECTED = e.target.options[e.target.selectedIndex].value

    LOGOS.forEach((LOGO) => {
      const DATA = LOGO.getAttribute('data-logos')
      const dataObj = JSON.parse(DATA)
      const currData = dataObj[SELECTED]

      if (currData.logo === null) {
        LOGO.classList.add('dm-secondary-logo--hide')
        return
      }
      LOGO.classList.remove('dm-secondary-logo--hide')

      // update logo text
      const TEXT_EL = LOGO.querySelector('.dm-secondary-logo__text')
      if (TEXT_EL) TEXT_EL.innerHTML = currData.text

      // update logo url and alt
      const IMG_EL = LOGO.querySelector('.dm-secondary-logo__image-container img')
      if (IMG_EL) {
        IMG_EL.alt = currData.logo.alt
        IMG_EL.src = currData.logo.url
      }

      // update anchors
      const ANCHOR_ELEMENTS = LOGO.querySelectorAll('.dm-secondary-logo__image-container a')
      if (ANCHOR_ELEMENTS.length > 0) {
        ANCHOR_ELEMENTS.forEach((ANCHOR) => ANCHOR.href = currData.logo.url)
      }
    })
  })
}